<agpr-take-over-panel
    [id]="id"
    [header]="'VisibilityIntelligence.competitorsSetupPanel.heading' | localize: {brandName: this.brand?.name ?? ''}"
    [ariaLabel]="'VisibilityIntelligence.competitorsSetupPanel.heading' | localize: {brandName: this.brand?.name ?? ''}"
    [responsiveWidth]="true"
    [minPanelWidth]="500"
    [maxPanelWidth]="500"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="agpr-competitorsSetupPanel">
        <agpr-scroll-panel>
            <div class="agpr-competitorsSetupPanel-content">
                <p class="agpr-competitorsSetupPanel-description">
                    {{ 'VisibilityIntelligence.competitorsSetupPanel.message' | localize }}
                </p>

                <div class="agpr-competitorsSetupPanel-field">
                    <div class="agpr-competitorsSetupPanel-fieldHeader">
                        <label class="agpr-competitorsSetupPanel-fieldLabel">
                            {{ 'VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.label' | localize }}
                        </label>
                        <span
                            role="img"
                            class="fa-regular fa-circle-info agpr-competitorsSetupPanel-FieldIcon"
                            agprTooltip="VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.tooltip"
                            tooltipPosition="right"
                        ></span>
                    </div>
                    <agpr-checkbox
                        [id]="id + '_competitorBenchmarking'"
                        label="VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.enable"
                        [(ngModel)]="isCompetitiveBenchmarking"
                        [binary]="true"
                    ></agpr-checkbox>
                </div>

                @if (isCompetitiveBenchmarking) {
                    <div class="agpr-competitorsSetupPanel-field">
                        <agpr-brand-competitors
                            [id]="id + '_competitors'"
                            label="VisibilityIntelligence.competitorsSetupPanel.competitorList.label"
                            [infoTooltip]="null"
                            tooltipPosition="left"
                            [hideItemActions]="true"
                            [maxLimit]="11"
                            [(ngModel)]="competitors"
                            [brand]="brand"
                        ></agpr-brand-competitors>
                    </div>
                }
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            [style]="buttonTypes.secondary"
            label="Core.button.noThanks"
            (click)="skip()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_continueButton'"
            [style]="buttonTypes.primary"
            label="continue"
            (click)="continue()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
